import { Typography } from "antd";
import ContactSupport from "components/Integrations/components/ContactSupport";
import { DOCS_URLS } from "constants/docsUrls";
import { Link } from "react-router-dom";

export const Footer: React.FC<object> = () => {
  return (
    <Typography.Paragraph>
      If you have any questions, please refer to our{" "}
      <Link to={DOCS_URLS.BASE} target="_blank" rel="noreferrer">
        documentation
      </Link>
      &nbsp;or&nbsp;
      <ContactSupport />
    </Typography.Paragraph>
  );
};
